var React = require('react');

function HoldRed (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M183.159 430.504C183.159 430.504 25.7746 404.111 54.5069 259.987C83.2392 115.863 364.678 104.155 364.678 104.155C364.678 104.155 432.407 134.001 445.854 154.879C487.277 219.199 461.244 291.179 424.82 343.066C352.447 446.16 183.159 430.504 183.159 430.504Z","fill":"#B32D19"}));
}

HoldRed.defaultProps = {"width":"519","height":"527","viewBox":"0 0 519 527","fill":"none"};

module.exports = HoldRed;

HoldRed.default = HoldRed;
